import axios from "axios";
import router from "../../router/index";

const state = {
  token: null,
  rol: null,
};

const getters = {
  isLogged: (state) => state.token !== null,
  getPerfil: (state) => state.rol,
};

const mutations = {
  setLoginInfo: (state, data) => {
    state.token = data.token;
    state.rol = data.rol;
  },
  clearAuthData: (state) => {
    state.token = null;
    state.rol = null;
  },
};

const actions = {
  async login({ commit }, data) {
    try {
      const resp = await axios.post("/v1/login", {
        usuario: data.usuario,
        clave: data.clave,
      });
      window.localStorage.setItem("_token_chatbot", resp.data.token);
      commit("setLoginInfo", resp.data);
      return resp;
    } catch (error) {
      window.localStorage.removeItem("_token_chatbot");
      commit("clearAuthData");
      return {
          error: true
      };
    }
  },

  logout: ({ commit }) => {
    window.localStorage.removeItem("_token_chatbot");
    commit("clearAuthData");
    router.push({ name: "Login" });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
